import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#2C2416',
        color: '#FFFFFF',
        py: 6,
        px: 2,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          {/* ---------- Left Section: About ---------- */}
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: '#FFFFFF',
              }}
            >
              SD Solutions
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: '#FFFFFF',
                opacity: 0.9,
                maxWidth: 450,
              }}
            >
              SD Solutions is your go-to home improvement partner, known for quality workmanship, reliable service, and a dedication to customer satisfaction throughout process.
            </Typography>
          </Grid>

          {/* ---------- Right Section: Contact Info ---------- */}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', sm: 'flex-end' },
              textAlign: { xs: 'left', sm: 'right' },
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 'bold', color: '#FFFFFF' }}
            >
              Contact Info
            </Typography>

            {/* Phone Link */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <PhoneIcon sx={{ mr: 1, fontSize: 20, color: '#D2691E' }} />
              <Link
                href="tel:+15082413648"
                underline="hover"
                sx={{ color: '#FFFFFF', fontSize: '0.9rem' }}
              >
                +1 (508) 241-3648
              </Link>
            </Box>

            {/* Email Link */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <EmailIcon sx={{ mr: 1, fontSize: 20, color: '#D2691E' }} />
              <Link
                href="mailto:sdsolutionstexas@gmail.com"
                underline="hover"
                sx={{ color: '#FFFFFF', fontSize: '0.9rem' }}
              >
                sdsolutionstexas@gmail.com
              </Link>
            </Box>

            {/* Address Link (Google Maps) */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <LocationOnIcon sx={{ mr: 1, fontSize: 20, color: '#D2691E' }} />
              <Link
                href="https://www.google.com/maps/place/SD+Solutions+LLC/@33.2765971,-96.5874098,17z/data=!4m16!1m9!3m8!1s0x22bbdd13f4360f2d:0x4ef1d7de893f6441!2sSD+Solutions+LLC!8m2!3d33.2762893!4d-96.5849231!9m1!1b1!16s%2Fg%2F11yrjqccpn!3m5!1s0x22bbdd13f4360f2d:0x4ef1d7de893f6441!8m2!3d33.2762893!4d-96.5849231!16s%2Fg%2F11yrjqccpn?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#FFFFFF', fontSize: '0.9rem' }}
              >
                1902 Gardenia Ct,
                <br />
                Melissa, TX 75454
              </Link>
            </Box>
          </Grid>
        </Grid>

        {/* ---------- Divider ---------- */}
        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: 1,
            borderColor: 'rgba(255, 255, 255, 0.2)',
          }}
        >
          <Typography
            variant="body2"
            align="center"
            sx={{ color: '#FFFFFF', opacity: 0.8 }}
          >
            © {new Date().getFullYear()} SD Solutions. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
